import { TResponse } from '../../common';
import { superAppApi } from '../../core';
import { IPermission } from '../../features/users/types';
import { IAuth, IPermissionValue, TSignInArgs } from '../types';

const headers = {
  // override the default headers
  'Content-Type': 'application/json',
};

export const authAPi = superAppApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (build) => ({
    signIn: build.mutation<IAuth, TSignInArgs>({
      query: (data) => ({
        url: '/auth/sign-in',
        method: 'POST',
        body: data,
        headers,
      }),
    }),
    resetPassword: build.mutation({
      query: (data) => ({
        url: '/auth/reset-password',
        method: 'POST',
        body: data,
        headers,
      }),
    }),
    getPermissions: build.query<IPermissionValue[], void>({
      query: () => ({
        url: '/auth/permissions',
        method: 'GET',
      }),
      transformResponse: (result: TResponse<IPermission[]>) =>
        result.data.map((permission) => ({
          title: permission.attributes.title,
          value: permission.id,
          disabled: !permission.attributes.status,
        })),
    }),
  }),
});

export const {
  useSignInMutation,
  useResetPasswordMutation,
  useGetPermissionsQuery,
} = authAPi;
